import { URLParser } from '../utils/URLParser';

export const searchParamIncludesValue = (searchParam, expectedValue) => {
  return (traffic) => {
    const urlObject = new URLParser(traffic.url);
    const value = urlObject.searchParams.get(searchParam);
    return value !== null && value.includes(expectedValue);
  };
};
